module.exports = __webpack_public_path__ + "img/s-for-sparkle_thumbnail.914256d5.jpg";